export default "__VITE_ASSET__B8$KhHqg__"